import React from 'react';
import _ from 'lodash';

import {
  SalesChannelName,
  useOrderListWidgetQuery
} from 'generated/graphql';

import { DateTime } from 'luxon';



export interface IOrder {
  id: string;
  orderNumber: string;
  orderDate: DateTime;
}

export interface IData {
  orders: IOrder[];
}

export function useQuery(salesChannel: SalesChannelName) {
  const tuple = useOrderListWidgetQuery({
    fetchPolicy: 'network-only',
    variables: {
      salesChannel
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        orders: _.map(tuple.data?.orders.nodes ?? [], (node): IOrder => ({
          id: node.id,
          orderNumber: node.orderNumber,
          orderDate: DateTime.fromISO(node.orderDate)
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
